import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
// Assets
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

export default function Header() {
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div>
          <h1 className="extraBold font60">The future of legal practice<span className="font18" style={{ display: "block", marginTop: "0.25em" }}>Built for your jurisdiction</span></h1>
          <HeaderP className="font13 semiBold">
            Secure case management, intelligent legal research, and AI-powered assistance designed specifically for modern law firms.
          </HeaderP>
          <BtnWrapper>
            <BtnInner>
              <FullButton title="Start 30-Day Free Trial" action={() => { window.location.href = "/trial-register"; }} />
            </BtnInner>
            {/* <BtnInner>
              <FullButton title="Get Started" action={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} />
            </BtnInner>
            <BtnInner>
              <FullButton title="Companion" border action={() => { window.location.href = "/login"; }} />
            </BtnInner> */}
          </BtnWrapper>
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <VideoStyled
            className="radius8"
            src="/video.mp4"
            autoPlay
            muted
            loop
            playsInline
            aria-label="Hero video"
          />
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
        <QuoteWrapper className="flexCenter darkBg radius8">
          <QuotesWrapper>
            <QuotesIcon />
          </QuotesWrapper>
          <div>
            <p className="font15 whiteColor">
              <em>Designed for lawyers. Not adapted for them.</em>
            </p>
            <p className="font13 orangeColor textRight" style={{marginTop: '10px'}}>Njobvu</p>
          </div>
        </QuoteWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
  );
}


const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  @media (max-width: 960px) {
    margin: 0 auto;
    justify-content: center;
  }
`;
const BtnInner = styled.div`
  width: fit-content;
  max-width: 200px;
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const VideoStyled = styled.video`
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  @media (max-width: 560px) {
    width: 80%;
  }
`;
const QuoteWrapper = styled.div`
  max-width: 330px;
  padding: 30px;
  margin-top: 24px;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    margin-left: 0;
    margin-right: auto;
  }
  @media (max-width: 560px) {
    margin-top: 20px;
    max-width: 100%;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;


